const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//	SEARCH
		// ===================================
		case "REVIEWER_SEARCH_IN_PROGRESS":
			return {
				...getBasicState(state),
				inProgress: 1
			};

		case "REVIEWER_SEARCH_HAS_ERROR":
			return {
				...state,
				error: action.error,
				inProgress: 0
			};

		case "REVIEWER_SEARCH_SUCCESS":
			return {
				...state,
				inProgress: 0,
				reviewers: action.data.data.reviewers
			};

		default:
			return state;
	}
};

/**
 * Returns only the basic necessity of state without all of the errors, success, etc.
 * @param object state
 */
function getBasicState(state) {
	const { error, success, ...newState } = state;
	return newState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/reviewerSearch.js